import { render, staticRenderFns } from "./order-uploader.vue?vue&type=template&id=11080908&scoped=true&"
import script from "./order-uploader.vue?vue&type=script&lang=ts&"
export * from "./order-uploader.vue?vue&type=script&lang=ts&"
import style0 from "./order-uploader.vue?vue&type=style&index=0&id=11080908&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11080908",
  null
  
)

export default component.exports